import styled from 'styled-components';
import { Divider, Button } from '@fluentui/react-components';

export const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  gap: 12px;
  padding: 12px 32px 20px 32px;
  display: flex;
  flex-direction: column;
`;

export const NotesContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0px 8px 40px 10px;
  height: 70vh;
  gap: 12px;
  overflow: auto;
`;

export const NotesDividerWrapper = styled.div`
  position: relative;
  width: 100%;
  justify-content: center;
  padding-bottom: 10px;
`;

export const NotesDivider = styled(Divider)`
  position: relative;
  ::before{
    border-color: ${(props) => props.theme.serviceDeskNotesDivider};
  }
  ::after{
    border-color: ${(props) => props.theme.serviceDeskNotesDivider};
  }
  padding: 0px 20px 0px 20px;
`;

export const NotesWrapper = styled.div`
  position: absolute;
  bottom: 12;
  width: 95%;
  gap: 8px;
`;

export const NotesInput = styled.div`
  width: 100%;
  cursor: auto;
  background-color: ${(props) => props.theme.serviceDeskInputNoteBackground};
  display: flex;
  flex-direction: column;
  outline: none;
  max-height: 100px;
  z-index: 0;

  &:after {
    content: '';
    border-bottom: solid 2px ${(props) => props.theme.selectedDateBackground};    
    transform: scaleX(0);   
  }
  &:focus-within:after { transform: scaleX(1); transition: transform 250ms ease-in; }
`;

export const NotesTextArea = styled.textarea`
  font-family: Segoe UI;
  width: 98%;
  padding: 0px 2px 7px 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.theme.serviceDeskNoteInputText};
  align-self: center;
  height: 64px;
  background-color: ${(props) => props.theme.serviceDeskInputNoteBackground};
  outline: none;

  :empty:before {
    content: attr(placeholder);
    color: #999;
  }
`;

export const ButtonsWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const StyledButton = styled(Button)`
  color: ${(props) => props.theme.selectedDateBackground};
  background-color: transparent;
  border: none;
`;